import { useContext, forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { OverflowContext } from "../utils/context";
import { mergeRefs } from "@churchofjesuschrist/eden-utilities";
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollContainer = styled.div.withConfig({
  componentId: "sc-cxooho-0"
})(["position:relative;overflow:auto;z-index:1;"]);

/** Use nested in the Fade component to enable scrolling with automatic fading of overflowing content. */
const Scrollable = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    renderAs,
    ...props
  } = _ref;
  const overflowRef = useContext(OverflowContext);
  return /*#__PURE__*/_jsx(ScrollContainer, {
    as: renderAs,
    ref: mergeRefs(overflowRef, forwardedRef),
    ...props,
    children: children
  });
});
Scrollable.displayName = "Scrollable";
Scrollable.propTypes = {
  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.elementType,
  /** The content to scroll. */
  children: PropTypes.node
};
export default Scrollable;